module.exports = __webpack_public_path__ + "206206061be9890a0aa453139a053392.jpg";